module.exports = {
	"Specifications": {
		"Model": "AC-230",
		"Fundamental Freq": "230 Hz",
		"Output Power": "150 db",
		"Weight": "56.5-59 lbs",
		"Length": "26.75 inches",
		"Air Requirements": "Pressure – 70-90 PSI<br />Consumption – 70-80 SCFM"
	},
	"Image": "/images/products/AC-230.jpg",
	"Thumbnail": "/images/products/small/AC-230.jpg",
	"Pdf": "/pdfs/AC-230 Data Sheet RevB.pdf"
};


//////////////////
// WEBPACK FOOTER
// ./products/ac-230.yaml
// module id = 567
// module chunks = 0